import React from "react";
import { inject } from "mobx-react";
import {
  FormGroup,
  Row,
  Col,
} from "reactstrap";

import PanelPasswordComponent from "./PanelPasswordComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { autoCompleteSx } from '../../helpers/utils'
import PaginationComponent from "../../components/PaginationComponent";
@inject("DeviceStore", "OrganizationStore")
class PanelPasswordContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      devices: []
    };
  }

  async componentDidMount() {
    this.getDevices();
  }

  getDevices = async (organization, organizationName, skip) => {
    this.setState({
      isLoading: true,
    });
    if (skip === undefined) skip = 0;
    const { DeviceStore } = this.props;
    let organizations = await this.getOrganizations(organizationName);
    if (organization === undefined) organization = organizations[0];
    const data = await DeviceStore.getDevices(organization.organizationId, skip);
    let devicesAux = [];
    let countItems = 0;
    let currentPage = 1;
    let countPages = 1;
    if (data && data !== "" && data.devices.length > 0) {
      devicesAux = data.devices;
      countItems = data.countItems;
      countPages = data.countPages;
    }  
    this.setState({
      organization: organization,
      organizations: organizations,
      devices: devicesAux,
      isLoading: false,
      currentPage: currentPage,
      countItems: countItems,
      countPages: countPages,
      skip: skip
    });
  };

  getOrganizations = async (value) => {
    const { OrganizationStore } = this.props;
    let organizationsData = await OrganizationStore.getOrganizations(value);
    return organizationsData.organizations;
  };

  onChange = async (device, field, value) => {
    if (field === "panelCurrentPassword")
    {
      value = Number(value);
      if ((value === 0 || value < 1 || isNaN(value))) {
        value = "";
      }
    }

    const { devices } = this.state;
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].deviceId === device.deviceId) {
        devices[i][field] = value;
        if (field === "passwordPanelActive") this.onClick(devices[i]);
        break;
      }
    }
    this.setState({
      devices
    });
  };

  onClick = async (device) => {
    const { DeviceStore } = this.props;

    this.setState({
      isLoading: true
    }); 

    let panelCurrentPassword = Number(device.panelCurrentPassword);
    if ((panelCurrentPassword === 0 || panelCurrentPassword < 1 || isNaN(panelCurrentPassword))) {
      device.panelCurrentPassword = 1;
    }
  
    let isOk = await DeviceStore.passwordPanelUpdate(device);
    if (isOk) {
      AlertComponent.success("Painel de senha atualizado com sucesso");
    } else {
      AlertComponent.error("Erro ao atualizar painel de senha");
    }

    this.setState({
      isLoading: false
    });
  };

  onKeyUpOrganization = async (value) => {
    try {
      let organizations = await this.getOrganizations(value);
      this.setState({
        organizations
      });
    }
    catch {}
  };

  onChangeOrganization = (organizationName) => {
    let { organizations, organization, skip } = this.state;
    for(let i = 0; i < organizations.length; i++){
      if (organizations[i].name === organizationName){
        organization = organizations[i];
        break;
      }
    }

    this.getDevices(organization, organizationName, skip);
  };

  onPageChange = async (currentPage) => {  
    this.setState({
      isLoading: true
    });  
    const skip = (currentPage - 1) * 100;
    const { organization } = this.state;
    await this.getDevices(organization, organization.name, skip);
    this.setState({
      currentPage: currentPage
    });
    this.setState({
      isLoading: false
    });
  };

  render() {
    const { isLoading, devices, organization, organizations, currentPage, countItems } = this.state;
    return (
      <>
        {(isLoading && (
            <LoadingComponent />
        )) || (
          <>
            <div className="content content-xs">            
              <Row>
                <Col xs={12} md={12}>
                  <FormGroup>
                    <span style={{marginBottom: "0px"}}>Estabelecimento:</span>
                    <Autocomplete
                      freeSolo
                      noOptionsText={"Nenhum item"}
                      onChange={(event, value) =>                         
                        this.onChangeOrganization(value)
                      }
                      style={{paddingBottom: "10px"}}                                      
                      value={organization?.name}
                      id="organization"
                      options={organizations.map((organization) => organization.name)}
                      isOptionEqualToValue={(option, value) => option.organizationId === value.organizationId}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          onInput={(e) => this.onKeyUpOrganization(e.target.value)}
                        />
                      )}
                      sx={autoCompleteSx()}
                      renderOption={(props, option) => {
                        return (
                          <span  {...props}>
                            {option}
                          </span>
                        );
                      }}                      
                    />
                    </FormGroup>
                  </Col>
              </Row>
              <Row>
                <Col xs={1} md={1}>
                  Código
                </Col>
                <Col xs={2} md={2}>
                  Título
                </Col>
                <Col xs={3} md={3}>
                  Estabelecimento
                </Col>
                <Col xs={2} md={2} style={{textAlign: "center"}}>
                  Painel de senha?
                </Col>
                <Col xs={2} md={2}>
                  Senha atual
                </Col>
              </Row>     
              <PanelPasswordComponent
                devices={devices}
                onClick={this.onClick}
                onChange={this.onChange}
              />
              <PaginationComponent
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={countItems}
                  onPageChange={this.onPageChange}
                />
            </div>
          </>
        )}
      </>
    );
  }
}

export default PanelPasswordContainer;
